import { logButtonClick } from 'features/navigation/utils/analytics';

import { ClickEventComponentNames } from 'state/amplitude';

export const logConfirmationDialogCta = (name: string) => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.PRODUCT_DETAIL_CLOSE_ACTION_CTA,
      name,
    },
  });
};
